const boxStyles = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'end',
    justifyContent: 'center',
    gap: '5px'
}

export default {
    commonStyles: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: {base: '5px', lg: '10px'},
        fontFamily: 'caslon',
        color: 'black.300',
        alignItems: 'center'
    },
    large: {
        headline: {
            color: 'inherit',
            fontSize: {base: '32px', lg: '42px'},
            fontWeight: '400',
            letterSpacing: {base: '0.16px', lg: '0.21px'},
            lineHeight: 'normal'
        },
        timer: {
            fontFamily: 'caslon'
        },
        label: {
            color: 'inherit',
            fontSize: {base: '24px', lg: '36px'},
            fontWeight: '400',
            letterSpacing: {base: '0.12px', lg: '0.18px'},
            lineHeight: {base: '32px', lg: '42px'},
            fontFamily: 'caslon'
        },
        cta: {
            color: 'inherit',
            fontSize: {base: '12px', lg: '18px'},
            fontWeight: '300',
            letterSpacing: {base: '0.06px', lg: '0.09px'},
            lineHeight: 'normal'
        },
        box: {
            ...boxStyles,
            gap: {base: '5px', md: '8px'},
            alignItems: 'center'
        },
        eyeBrow: {
            fontSize: {base: '16px', lg: '42px'},
            letterSpacing: {base: '0.08px', lg: '0.21px'},
            fontWeight: '400',
            lineHeight: 'normal'
        },
        eyeBrowTimer: {
            fontSize: {base: '14px', lg: '42px'},
            letterSpacing: {base: '0.08px', lg: '0.21px'},
            fontWeight: '400',
            lineHeight: 'normal'
        },
        eyeBrowLabel: {
            fontSize: {base: '12px', lg: '36px'},
            letterSpacing: {base: '0.06px', lg: '0.18px'},
            lineHeight: 'normal'
        }
    },
    medium: {
        headline: {
            color: 'inherit',
            fontSize: {base: '16px', lg: '24px'},
            fontWeight: '400',
            letterSpacing: {base: '0.08px', lg: '0.12px'},
            lineHeight: 'normal'
        },
        numStyles: {
            color: 'inherit',
            fontSize: {base: '18px', lg: '24px'},
            fontWeight: '400',
            letterSpacing: {base: '0.08px', lg: '0.12px'},
            lineHeight: 'normal',
            fontFamily: 'caslon'
        },
        timer: {
            fontFamily: 'caslon'
        },
        label: {
            color: 'inherit',
            fontSize: {base: '14px', lg: '18px'},
            fontWeight: '400',
            letterSpacing: {base: '0.07px', lg: '0.09px'},
            lineHeight: {base: '16px', lg: '24px'},
            fontFamily: 'caslon'
        },
        cta: {
            color: 'inherit',
            fontSize: {base: '10px', lg: '14px'},
            fontWeight: '300',
            letterSpacing: {base: '0.05px', lg: '0.07px'},
            lineHeight: 'normal'
        },
        box: {...boxStyles},
        eyeBrow: {},
        eyeBrowLabel: {}
    },
    small: {
        headline: {
            color: 'inherit',
            fontSize: {base: '16px', lg: '18px'},
            fontWeight: '400',
            letterSpacing: {base: '0.07px', lg: '0.9px'},
            lineHeight: 'normal'
        },
        timer: {
            fontFamily: 'caslon'
        },
        label: {
            color: 'inherit',
            fontSize: {base: '12px', lg: '16px'},
            fontWeight: '400',
            letterSpacing: {base: '0.07px', lg: '0.08px'},
            lineHeight: {base: '14px', lg: '18px'},
            fontFamily: 'caslon'
        },
        cta: {
            color: 'inherit',
            fontSize: {base: '8px', lg: '12px'},
            fontWeight: '300',
            letterSpacing: {base: '0.04px', lg: '0.06px'},
            lineHeight: 'normal'
        },
        box: {...boxStyles},
        eyeBrow: {},
        eyeBrowLabel: {}
    },
    hero: {
        headline: {
            color: 'inherit',
            fontSize: {base: '48px', lg: '64px'},
            fontWeight: '700',
            letterSpacing: {base: '0.24px', lg: '0.32px'},
            lineHeight: 'normal'
        },
        label: {
            color: 'inherit',
            fontSize: {base: '36px', lg: '48px'},
            fontWeight: '400',
            letterSpacing: {base: '0.07px', lg: '0.08px'},
            lineHeight: {base: '48px', lg: '64px'}
        },
        eyeBrow: {
            fontSize: '32px',
            letterSpacing: '0.16px',
            fontWeight: '400',
            lineHeight: 'normal'
        },
        eyeBrowLabel: {
            color: 'inherit',
            fontSize: '24px',
            fontWeight: '400',
            letterSpacing: '0.12px',
            lineHeight: '32px'
        },
        box: {
            ...boxStyles,
            gap: {base: '6px', md: '8px'},
            flexWrap: {base: 'wrap', md: 'nowrap'}
        }
    }
}
